export function Loader(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C11.4477 0 11 0.447715 11 1V7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7V1C13 0.447715 12.5523 0 12 0Z"
          fill="currentColor"
        />
        <path
          d="M12 16C11.4477 16 11 16.4477 11 17V23C11 23.5523 11.4477 24 12 24C12.5523 24 13 23.5523 13 23V17C13 16.4477 12.5523 16 12 16Z"
          fill="currentColor"
        />
        <path
          d="M3.51472 4.92893C3.1242 4.53841 3.1242 3.90524 3.51472 3.51472C3.90525 3.12419 4.53841 3.12419 4.92894 3.51472L9.17158 7.75736C9.5621 8.14788 9.5621 8.78105 9.17158 9.17157C8.78105 9.5621 8.14789 9.5621 7.75736 9.17157L3.51472 4.92893Z"
          fill="currentColor"
        />
        <path
          d="M14.8284 14.8284C14.4379 15.219 14.4379 15.8521 14.8284 16.2426L19.0711 20.4853C19.4616 20.8758 20.0948 20.8758 20.4853 20.4853C20.8758 20.0948 20.8758 19.4616 20.4853 19.0711L16.2427 14.8284C15.8521 14.4379 15.219 14.4379 14.8284 14.8284Z"
          fill="currentColor"
        />
        <path
          d="M1 13C0.447715 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H7C7.55228 11 8 11.4477 8 12C8 12.5523 7.55228 13 7 13H1Z"
          fill="currentColor"
        />
        <path
          d="M16 12C16 12.5523 16.4477 13 17 13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11H17C16.4477 11 16 11.4477 16 12Z"
          fill="currentColor"
        />
        <path
          d="M4.92891 20.4853C4.53838 20.8758 3.90522 20.8758 3.51469 20.4853C3.12417 20.0948 3.12417 19.4616 3.51469 19.0711L7.75734 14.8284C8.14786 14.4379 8.78102 14.4379 9.17155 14.8284C9.56207 15.219 9.56207 15.8521 9.17155 16.2426L4.92891 20.4853Z"
          fill="currentColor"
        />
        <path
          d="M14.8284 9.17157C15.2189 9.5621 15.8521 9.5621 16.2426 9.17157L20.4853 4.92893C20.8758 4.53841 20.8758 3.90524 20.4853 3.51472C20.0947 3.1242 19.4616 3.1242 19.0711 3.51472L14.8284 7.75736C14.4379 8.14788 14.4379 8.78105 14.8284 9.17157Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
